export const SAVE_ALL_VEHICLE_MODELS = 'SAVE_ALL_VEHICLE_MODELS'
export const SAVE_VEHICLE_MODEL = 'SAVE_VEHICLE_MODEL'
